import type { MessageInteractivePresentationDto } from "@multi-chat/shared";

type Translate = (key: string) => string;

export function interactiveFallbackLabel(
  presentation: MessageInteractivePresentationDto | undefined,
  t: Translate,
): string {
  const kind = presentation?.kind ?? "unknown";
  switch (kind) {
    case "button_reply":
    case "list_reply":
      return t("inbox.messageType.INTERACTIVE");
    case "nfm_reply":
      return t("inbox.interactive.nfmReply");
    case "product":
      return t("inbox.interactive.product");
    case "unknown":
      return t("inbox.interactive.unknown");
    default: {
      const _exhaustive: never = kind;
      return _exhaustive;
    }
  }
}
